import React from 'react';

import { Route, Switch } from 'react-router-dom';

import Index from './components/Index';
import Session from './components/Session';
import Init from './components/sessions/Init';
import Reapply from './components/sessions/Reapply';
import Apply from './components/sessions/Apply';
import Purchase from './components/sessions/Purchase';
import Finish from './components/sessions/Finish';
import Error from './components/Error';
import Invalid from './components/Invalid';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft, faCheck, faCircle, faCircleXmark, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

import {
  faCheckCircle,
  faInfoCircle,
  faQuestionCircle,
  faTimes as falTimes,
  faSpinnerThird,
  faLockAlt,
  faRepeat,
  faCircleQuestion,
  faCheck as falCheck,
  faBuilding,
  faShop,
  faChevronRight,
} from '@fortawesome/pro-light-svg-icons';

import {
  faMoneyBillTrendUp,
  faBadgePercent,
  faCalendarCheck,
  faTriangleExclamation,
  faArrowRight,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faCircleDollar,
  faCircleCalendar,
  faBagsShopping,
} from '@fortawesome/pro-solid-svg-icons';
import { ProvideAuth } from './hooks/useAuth';

// Add icons to FA library for global usage
library.add(
  falCheck,
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faPlus,
  faQuestionCircle,
  faTimes,
  falTimes,
  faSpinnerThird,
  faLockAlt,
  faThumbsUp,
  faRepeat,
  faCircleDollar,
  faCircleCalendar,
  faBagsShopping,
  faBadgePercent,
  faMoneyBillTrendUp,
  faCalendarCheck,
  faCircleQuestion,
  faCircleXmark,
  faArrowLeft,
  faBuilding,
  faShop,
  faCircle,
  faChevronRight,
  faTriangleExclamation,
  faArrowRight
);

export const fromLearnMore = new URLSearchParams(window.location.search).get('learn-more')

export const workflows = [
  {
    path: '/init',
    component: Init,
  },
  {
    path: '/reapply',
    component: Reapply,
  },
  {
    path: '/apply',
    component: Apply,
  },
  {
    path: '/purchase',
    component: Purchase,
  },
  {
    path: '/finish',
    component: Finish,
  },
  {
    path: '/invalid',
    component: Invalid,
  },
  {
    path: '/error',
    component: Error,
  },
];

export default function App() {
  return (
    <ProvideAuth>
      <div className="App overflow-hidden">
        <Switch>
          <Route exact path="/" component={Index} />
          <Route path={workflows.map((w) => w.path)} component={Session} />
          <Route path="/:public_key/:prequalification_id?" component={Session} />
        </Switch>
      </div>
    </ProvideAuth>
  );
}
